import React, { createContext, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import HomePage from './Pages/HomePage';
import CareersPage from './Pages/CareersPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Css/careers.css'
import './Css/home.css'
import './Css/hrsection.css'
import './Css/service.css'
import Footer from './Component/Footer';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactPage from './Pages/ContactPage';
import HrmsPublish from './Pages/HrmsPublish';
import ServicePage from './Pages/ServicePage';
import SubServicePage from './Pages/SubServicePage';
import SectorsPage from './Pages/SectorsPage';
import ParticularCareerPage from './Pages/ParticularCareerPage';
import AllBlogPage from './Pages/AllBlogPage';
import ParticularBlog from './Pages/ParticularBlog';
import 'react-toastify/dist/ReactToastify.css';
import EventPage from './Pages/Events/EventsPage';
import ParticularEvent from './Pages/Events/ParticularEventPage';
import IndustryPage from './Pages/IndustryPage';
import MainIndustryPage from './Pages/MainIndustryPage';
import WhyMeridaPage from './Pages/WhyMeridaPage';
import GlobalEnquiryModal from './Component/GlobalEnquiryModal';
import LocationPage from './Pages/LocationPage';
import NotFound from './Pages/NotFound';
import WebsiteChatWidget from './Component/ChatWidget/WebsiteChatWidget';

export const GlobalEnquiryContext = createContext();

// export const port = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
//   ? 'http://localhost:8000'
//   : 'https://backendapi.meridahr.com';
export const port = 'https://backendapi.meridahr.com'
export const slaport = 'https://backendapi.skilllearningacademy.com'
// export const port = 'http://192.168.218.249:7000'
// export const hrport='http://192.168.218.237:3000'
export const hrport = 'https://hrm.meridahr.com'
export const hrmJobPort = 'https://hrmbackendapi.meridahr.com'
export const domain = 'https://www.meridahr.com'

function App() {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [enquirySource, setEnquirySource] = useState("General");
  const [enquiryFields, setEnquiryFields] = useState([]);

  const openEnquiry = (source = "General", fields = []) => {
    setEnquirySource(source);
    setEnquiryFields(fields);
    setIsEnquiryOpen(true);
  };

  return (
    <div className="">
      <GlobalEnquiryContext.Provider value={{ openEnquiry }}>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/careers/*' element={<CareersPage />} />
            <Route path='/jobs/:slug' element={<ParticularCareerPage />} />

            <Route path='/contact' element={<ContactPage />} />
            <Route path='/about' element={<HrmsPublish />} />
            <Route path='/service' element={<ServicePage />} />
            <Route path='/service/:sid' element={<ServicePage />} />
            <Route path='/service/:sid/:subsid' element={<SubServicePage />} />
            <Route path='/industries/information-technology' element={<IndustryPage />} />
            <Route path='/industries/it-and-software-recruitment-services' element={<IndustryPage />} />
            <Route path='/industries/healthcare' element={<IndustryPage />} />
            <Route path='/industries/manufacturing' element={<IndustryPage />} />
            <Route path='/industries/bfsi' element={<IndustryPage />} />
            <Route path='/industries/ecommerce' element={<IndustryPage />} />
            <Route path='/industries/logistics' element={<IndustryPage />} />
            <Route path='/industries/startups' element={<IndustryPage />} />
            <Route path='/industries/gcc' element={<IndustryPage />} />
            <Route path='/industries/:id' element={<SectorsPage />} />
            <Route path='/blogs/:slug' element={<ParticularBlog />} />
            <Route path='/blogs/*' element={<AllBlogPage />} />

            <Route path='/events/*' element={<EventPage />} />
            <Route path='/events/:slug' element={<ParticularEvent />} />
            <Route path='/industry' element={<MainIndustryPage />} />
            <Route path='/why-merida' element={<WhyMeridaPage />} />
            <Route path='/locations/:slug' element={<LocationPage />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
          <Footer />
          <GlobalEnquiryModal 
            isOpen={isEnquiryOpen} 
            onClose={() => setIsEnquiryOpen(false)} 
            sourcePage={enquirySource} 
            customFields={enquiryFields} 
          />
          <WebsiteChatWidget />
        </BrowserRouter>
      </GlobalEnquiryContext.Provider>
    </div>
  );
}

export default App;
